import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { CREATIVE_CATEGORIES, CREATIVE_STAGES_SELECT, CREATIVE_GOALS } from "../../content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EMPTY = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  website: "",
  category: CREATIVE_CATEGORIES[0],
  stage: CREATIVE_STAGES_SELECT[0],
  goal: CREATIVE_GOALS[0],
  message: "",
};

export const CreativeLeadForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/creative-lead`, form);
      toast.success("Growth profile received. Roy will review it and reach out directly.");
      setForm(EMPTY);
    } catch (err) {
      toast.error("Something went wrong. Please email Roy directly at yestosuccess@collabignite.com.");
    } finally {
      setSending(false);
    }
  };

  const Select = ({ testid, value, onChange, options, label }) => (
    <label className="block">
      <span className="mb-1.5 block font-mono text-[10px] uppercase tracking-[0.2em] text-golddeep">{label}</span>
      <select data-testid={testid} className="field" value={value} onChange={onChange}>
        {options.map((o) => (
          <option key={o} value={o}>{o}</option>
        ))}
      </select>
    </label>
  );

  return (
    <form data-testid="creative-lead-form" onSubmit={submit} className="grid gap-5 sm:grid-cols-2">
      <label className="block">
        <span className="mb-1.5 block font-mono text-[10px] uppercase tracking-[0.2em] text-golddeep">First name *</span>
        <input data-testid="lead-first-name" className="field" value={form.first_name} onChange={set("first_name")} required />
      </label>
      <label className="block">
        <span className="mb-1.5 block font-mono text-[10px] uppercase tracking-[0.2em] text-golddeep">Last name *</span>
        <input data-testid="lead-last-name" className="field" value={form.last_name} onChange={set("last_name")} required />
      </label>
      <label className="block">
        <span className="mb-1.5 block font-mono text-[10px] uppercase tracking-[0.2em] text-golddeep">Email *</span>
        <input data-testid="lead-email" className="field" type="email" value={form.email} onChange={set("email")} required />
      </label>
      <label className="block">
        <span className="mb-1.5 block font-mono text-[10px] uppercase tracking-[0.2em] text-golddeep">Phone</span>
        <input data-testid="lead-phone" className="field" value={form.phone} onChange={set("phone")} />
      </label>
      <label className="block sm:col-span-2">
        <span className="mb-1.5 block font-mono text-[10px] uppercase tracking-[0.2em] text-golddeep">Website or social media</span>
        <input data-testid="lead-website" className="field" placeholder="Your strongest link" value={form.website} onChange={set("website")} />
      </label>
      <Select testid="lead-category" label="Creative category" value={form.category} onChange={set("category")} options={CREATIVE_CATEGORIES} />
      <Select testid="lead-stage" label="Current stage" value={form.stage} onChange={set("stage")} options={CREATIVE_STAGES_SELECT} />
      <div className="sm:col-span-2">
        <Select testid="lead-goal" label="Primary growth goal" value={form.goal} onChange={set("goal")} options={CREATIVE_GOALS} />
      </div>
      <label className="block sm:col-span-2">
        <span className="mb-1.5 block font-mono text-[10px] uppercase tracking-[0.2em] text-golddeep">What are you trying to build? *</span>
        <textarea data-testid="lead-message" className="field" rows={5} value={form.message} onChange={set("message")} required minLength={10} />
      </label>
      <div className="sm:col-span-2">
        <button data-testid="lead-submit-btn" type="submit" disabled={sending} className="btn-gold w-full sm:w-auto disabled:opacity-60">
          {sending ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />}
          {sending ? "Sending…" : "Submit My Growth Profile"}
        </button>
      </div>
    </form>
  );
};
